import React, { useState } from "react";
import Context from "./index";
import { getAll, create, getSingle } from "../../Api/AuthApi";
import { message, Form } from "antd";
import dayjs from 'dayjs';

const FreecashProvider = ({ children, ...props }) => {

const [adFreecashListFilter, setAdFreecashListFilter] = useState({
  limit: 10,
  page: 1,
  freecash_label: "",
});
const [adFreecashHistoryFilter, setAdFreecashHistoryFilter] = useState({
  limit: 10,
  page: 1,
  customer_name: "",
});
const [adFreecashHistoryLoader, setAdFreecashHistoryLoader] = useState(false);
const [adFreecashHistory, setAdFreecashHistory] = useState([]);
const [adFreecashListLoader, setAdFreecashListLoader] = useState(false);
const [adFreecashList, setAdFreecashList] = useState([]);
const [adProdDropdown, setAdProdDropdown] = useState([]);
const [adProdDropdownLoader, setAdProdDropdownLoader] = useState(false);
const [adFreecashAddLoader, setAdFreecashAddLoader] = useState(false);
const [adFreecashSingleLoader, setAdFreecashSingleLoader] = useState(false);
const [adFreecashCommonListLoader, setAdFreecashCommonListLoader] = useState(false);
const [adFreecashSingle, setAdFreecashSingle] = useState({});
const [adFreecashCommonList, setAdFreecashCommonList] = useState({});
const [adFreecashUpdateLoader, setAdFreecashUpdateLoader] = useState(false);
const [adFreecashCommonLoader, setAdFreecashCommonLoader] = useState(false);

const [adFreecashForm] = Form.useForm();
const [adFreecashFormEdit] = Form.useForm();
const [adFreecashCommonForm] = Form.useForm();



async function adFreecashListFetch() {
  const token_data = localStorage.getItem("nattu_admin_token");
  if (!token_data) return;
  setAdFreecashListLoader(true);
  await getAll("freecash.php?action=freecashlist", adFreecashListFilter)
    .then((res) => {
      if (res?.status === 200 && res?.success === true) {
        setAdFreecashList(res?.data);
        setAdFreecashListLoader(false);
      } else {
        setAdFreecashList([]);
        setAdFreecashListLoader(false);
      }
    })
    .catch((err) => {
      setAdFreecashList([]);
      setAdFreecashListLoader(false);
    });
}

async function adFreecashHistoryFetch() {
  const token_data = localStorage.getItem("nattu_admin_token");
  if (!token_data) return;
  setAdFreecashHistoryLoader(true);
  await getAll("freecash.php?action=freecashhistory", adFreecashHistoryFilter)
    .then((res) => {
      if (res?.status === 200 && res?.success === true) {
        setAdFreecashHistory(res?.data);
        setAdFreecashHistoryLoader(false);
      } else {
        setAdFreecashHistory([]);
        setAdFreecashHistoryLoader(false);
      }
    })
    .catch((err) => {
      setAdFreecashHistory([]);
      setAdFreecashHistoryLoader(false);
    });
}

  async function adProdDropDownFetch() {
    const token_data = localStorage.getItem("nattu_admin_token");
    if (!token_data) return;
    setAdProdDropdownLoader(true);
    await getAll("freecash.php?action=productdropdown")
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          setAdProdDropdown(res?.data);
          setAdProdDropdownLoader(false);
        } else {
          setAdProdDropdown([]);
          setAdProdDropdownLoader(false);
        }
      })
      .catch((err) => {
        setAdProdDropdown([]);
        setAdProdDropdownLoader(false);
      });
  }

    async function adFreecashAdd(
    data = {},
    navigate
  ) {
    const token_data = localStorage.getItem("nattu_admin_token");
    if (!token_data) return;
    setAdFreecashAddLoader(true);

    const form_data = new FormData();
    form_data.append("freecash_label", data?.freecash_label || "");    
    form_data.append("freecash_status", data?.freecash_status == true ? 1 : 0);

    form_data.append("freecash_starts_at", data?.freecash_starts_at?.format("YYYY-MM-DD") || "");
    form_data.append("freecash_ends_at", data?.freecash_ends_at?.format("YYYY-MM-DD") || "");

    form_data.append("is_all_product", data?.is_all_product == 'yes' ? 1 : 0);
    form_data.append("freecash_type", data?.freecash_type == 'amount' ? 1 : 2);
    form_data.append("freecash_amount", data?.freecash_amount || 0);
    form_data.append("freecash_percentage", data?.freecash_percentage || 0);
    if (data?.product_id && Array.isArray(data.product_id)) {
      data.product_id.forEach(productId => {
        form_data.append("product_id[]", productId);
      });
    } else if (data?.product_id) {
      form_data.append("product_id[]", data.product_id);
    }    
    await create("freecash.php?action=freecashcreate", form_data)
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          adFreecashForm.resetFields();
          // calback();
          setAdFreecashAddLoader(false);
          navigate("/admin/freecash");
        } else {
          message.error(res?.message);
          setAdFreecashAddLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setAdFreecashAddLoader(false);
      });
  }

    async function adFreecashUpdate(
    data = {},
    id,
    navigate
  ) {
    const token_data = localStorage.getItem("nattu_admin_token");
    if (!token_data) return;
    setAdFreecashUpdateLoader(true);
    console.log(data);
    const form_data = new FormData();
    form_data.append("freecash_label", data?.freecash_label || "");    
    form_data.append("freecash_status", data?.freecash_status == true ? 1 : 0);

    form_data.append("freecash_starts_at", data?.freecash_starts_at?.format("YYYY-MM-DD") || "");
    form_data.append("freecash_ends_at", data?.freecash_ends_at?.format("YYYY-MM-DD") || "");

    form_data.append("is_all_product", data?.is_all_product == 'yes' ? 1 : 0);
    form_data.append("freecash_type", data?.freecash_type == 'amount' ? 1 : 2);
    form_data.append("freecash_amount", data?.freecash_amount || 0);
    form_data.append("freecash_percentage", data?.freecash_percentage || 0);
    if (data?.product_id && Array.isArray(data.product_id)) {
      data.product_id.forEach(productId => {
        form_data.append("product_id[]", productId);
      });
    } else if (data?.product_id) {
      form_data.append("product_id[]", data.product_id);
    } 
    
    await create("freecash.php?action=freecashupdate&freecash_id=" + id,
      form_data)
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          adFreecashFormEdit.resetFields();
          setAdFreecashUpdateLoader(false);
          navigate("/admin/freecash");
        } else {
          message.error(res?.message);
          setAdFreecashUpdateLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setAdFreecashUpdateLoader(false);
      });
  }


async function editFreecashFetch(id) {
  const token_data = localStorage.getItem("nattu_admin_token");
  if (!token_data) return;
  setAdFreecashSingleLoader(true);
  await getSingle(`freecash.php?action=freecashsingle&freecash_id=${id}`)
    .then((res) => {
      if (res?.status === 200 && res?.success === true) {
        setAdFreecashSingle(res?.data);
        const freecashType = res?.data.freecash_type === 1 ? 'amount' : 'percentage';
        const isAllProd = res?.data.is_all_product === 1 ? 'yes' : 'no';


        const parseDBDate = (dateString) => {
          if (!dateString) return null;
          return dayjs(dateString, 'YYYY-MM-DD HH:mm:ss');
        };
        const startsAt = parseDBDate(res?.data.freecash_starts_at);
        const endsAt = parseDBDate(res?.data.freecash_ends_at);

        adFreecashFormEdit.setFieldsValue({
          ...res?.data,
          product_id: res?.data?.product_id
            ?.split(",")
            .map((prodId) => prodId),
          freecash_starts_at: startsAt,
          freecash_ends_at: endsAt,
          freecash_type: freecashType,
          is_all_product: isAllProd,
          freecash_status: res?.data.freecash_status
        });
        setAdFreecashSingleLoader(false);
      } else {
        setAdFreecashSingle({});
        setAdFreecashSingleLoader(false);
      }
    })
    .catch((err) => {
      setAdFreecashSingle({});
      setAdFreecashSingleLoader(false);
    });
}


async function commonFreecashFetch(id) {
  const token_data = localStorage.getItem("nattu_admin_token");
  if (!token_data) return;
  setAdFreecashCommonListLoader(true);
  await getSingle(`freecash.php?action=freecashcommonlist`)
    .then((res) => {
      if (res?.status === 200 && res?.success === true) {
        setAdFreecashCommonList(res?.data);
        adFreecashCommonForm.setFieldsValue({
          ...res?.data,
          status: res?.data.status
        });
        setAdFreecashCommonListLoader(false);
      } else {
        setAdFreecashCommonList({});
        setAdFreecashCommonListLoader(false);
      }
    })
    .catch((err) => {
      setAdFreecashCommonList({});
      setAdFreecashCommonListLoader(false);
    });
}

    async function adFreecashCommon(
    data = {},
    id,
    navigate
  ) {
    const token_data = localStorage.getItem("nattu_admin_token");
    if (!token_data) return;
    setAdFreecashCommonLoader(true);

    const form_data = new FormData();
    form_data.append("status", data?.status == true ? 1 : 0);
    form_data.append("maximum_redeem_amount", data?.maximum_redeem_amount || 0);
    form_data.append("success_message", data?.success_message || "");
    form_data.append("customer_notify", data?.customer_notify == 'yes' ? 1 : 0);
    form_data.append("notify_message", data?.notify_message || "");

    await create("freecash.php?action=freecashcommon", form_data)
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          adFreecashCommonForm.resetFields();
          // calback();
          setAdFreecashCommonLoader(false);
          navigate("/admin/freecash");
        } else {
          message.error(res?.message);
          setAdFreecashCommonLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setAdFreecashCommonLoader(false);
      });
  }



  return (
    <Context.Provider
      value={{
        ...props,
        adFreecashListFilter,
        setAdFreecashListFilter,
        adFreecashHistoryFilter,
        setAdFreecashHistoryFilter,
        adFreecashListLoader,
        setAdFreecashListLoader,
        adFreecashList,
        setAdFreecashList,
        adFreecashHistoryLoader,
        setAdFreecashHistoryLoader,
        adFreecashHistory,
        setAdFreecashHistory,
        adFreecashListFetch,
        adFreecashHistoryFetch,
        adProdDropdown,
        setAdProdDropdown,
        adProdDropdownLoader,
        setAdProdDropdownLoader,
        adProdDropDownFetch,
        adFreecashAdd,
        adFreecashAddLoader,
        setAdFreecashAddLoader,
        adFreecashForm,
        adFreecashSingleLoader,
        setAdFreecashSingleLoader,
        setAdFreecashCommonListLoader,
        adFreecashCommonListLoader,
        adFreecashSingle,
        setAdFreecashSingle,
        adFreecashCommonList,
        setAdFreecashCommonList,
        adFreecashFormEdit,
        adFreecashCommonForm,
        adFreecashUpdate,
        adFreecashUpdateLoader,
        setAdFreecashUpdateLoader,
        editFreecashFetch,
        commonFreecashFetch,
        setAdFreecashCommonLoader,
        adFreecashCommonLoader,
        adFreecashCommon,

      }}
    >
      {children}
    </Context.Provider>
  );
};

export default FreecashProvider;
